// extracted by mini-css-extract-plugin
export default {"intro_wrap":"IntroScreen_intro_wrap__JnP1R","intro_area":"IntroScreen_intro_area__UVkX5"};